import { Ref } from "react";

import StarRounded from "@mui/icons-material/StarOutlineRounded";
import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

import { useCurrentUserContext } from "@/common/contexts/current-user-context/CurrentUserContext";
import { useTranslation } from "@/translations";

interface Props {
  highlighted: boolean;
  onClick: () => void;
  id: string;
  ariaSelected: boolean;
  ref: Ref<HTMLLIElement>;
}

export const MyClientsListItem = ({ highlighted, onClick, id, ariaSelected, ref }: Props) => {
  const { t } = useTranslation();
  const { currentUser } = useCurrentUserContext();

  return (
    <ListItemButton
      component="li"
      ref={ref}
      id={id}
      role="option"
      aria-selected={ariaSelected}
      /**
       * Must use onMouseDown to fires before onBlur on the Search Field
       * Otherwise, onBlur closes popper and onClick will never be fired
       */
      onMouseDown={onClick}
      tabIndex={-1}
      sx={{ px: 2, py: 1, bgcolor: highlighted ? "action.selected" : "transparent" }}
    >
      <ListItemIcon sx={{ minWidth: 0, mr: 4, justifyContent: "center" }}>
        <StarRounded />
      </ListItemIcon>
      <ListItemText
        primary={t("layout.header.clientSmartSearch.myClients", { currentUserAbb: currentUser.userCode })}
        slotProps={{ primary: { noWrap: true } }}
      />
    </ListItemButton>
  );
};
